import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  IoChatbubblesOutline, 
  IoLogoWhatsapp, 
  IoCallOutline, 
  IoMailOutline, 
  IoChevronForward, 
  IoInformationCircleOutline,
  IoChatbubbleEllipsesOutline
} from 'react-icons/io5';

// Web Storage wrapper (using localStorage)
const storage = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      //console.error('Error getting item from localStorage:', error);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      //console.error('Error setting item in localStorage:', error);
    }
  }
};

// Styles
const styles = {
  mainContainer: {
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    flexDirection: 'column',
  },
  scrollContainer: {
    flex: 1,
    padding: '20px',
    maxWidth: '800px',
    margin: '0 auto',
    width: '100%',
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px',
    minHeight: '400px',
  },
  loadingSpinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #137a7f',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  loadingText: {
    marginTop: '16px',
    fontSize: '16px',
    color: '#666',
    textAlign: 'center',
  },
  headerContainer: {
    alignItems: 'center',
    marginBottom: '30px',
    padding: '20px',
    textAlign: 'center',
  },
  headerIcon: {
    fontSize: '48px',
    color: '#137a7f',
  },
  title: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#137a7f',
    textAlign: 'center',
    marginTop: '16px',
    marginBottom: '8px',
  },
  subtitle: {
    fontSize: '16px',
    color: '#666',
    textAlign: 'center',
  },
  contactCard: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    borderWidth: '1px',
    borderColor: '#e0e0e0',
    borderStyle: 'solid',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
  contactCardHover: {
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 12px rgba(0,0,0,0.15)',
  },
  disabledCard: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  cardIconContainer: {
    marginRight: '16px',
  },
  cardIcon: {
    fontSize: '32px',
  },
  cardContent: {
    flex: 1,
  },
  contactType: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#999',
    marginBottom: '4px',
    textTransform: 'uppercase',
  },
  contactValue: {
    fontSize: '18px',
    fontWeight: '500',
    color: '#333',
    marginBottom: '4px',
  },
  contactHint: {
    fontSize: '14px',
    color: '#666',
  },
  chevronIcon: {
    fontSize: '24px',
    color: '#999',
  },
  infoContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#e8f4f8',
    borderRadius: '12px',
    padding: '16px',
    marginTop: '20px',
  },
  infoIcon: {
    fontSize: '20px',
    color: '#666',
  },
  infoText: {
    fontSize: '14px',
    color: '#137a7f',
    marginLeft: '12px',
    flex: 1,
  },
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
  },
  emptyIcon: {
    fontSize: '64px',
    color: '#ccc',
  },
  emptyText: {
    fontSize: '16px',
    color: '#666',
    textAlign: 'center',
    marginTop: '16px',
  },
  emptySubText: {
    fontSize: '14px',
    color: '#666',
    textAlign: 'center',
    marginTop: '8px',
  },
  navbar: {
    backgroundColor: '#137a7f',
    padding: '16px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  navbarTitle: {
    color: 'white',
    fontSize: '18px',
    fontWeight: '600',
    margin: 0,
  },
  backButton: {
    position: 'absolute',
    left: '20px',
    background: 'none',
    border: 'none',
    color: 'white',
    fontSize: '20px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  backButtonText: {
    fontSize: '14px',
  },
  footer: {
    backgroundColor: '#f5f5f5',
    padding: '10px',
    textAlign: 'center',
    borderTopWidth: '1px',
    borderTopColor: '#e0e0e0',
    borderTopStyle: 'solid',
  },
  footerText: {
    fontSize: '12px',
    color: '#666',
    margin: 0,
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: '15px',
    padding: '20px',
    width: '90%',
    maxWidth: '400px',
  },
  modalTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#137a7f',
    marginBottom: '20px',
    textAlign: 'center',
  },
  modalButtons: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
    marginTop: '20px',
  },
  modalButton: {
    padding: '10px 20px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
  },
  modalButtonCancel: {
    backgroundColor: '#f0f0f0',
    color: '#666',
  },
  modalButtonConfirm: {
    backgroundColor: '#137a7f',
    color: 'white',
  },
};

// Add keyframes animation
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);

// NavBar Component
const NavBar = ({ title, showBackButton = false }) => {
  const navigate = useNavigate();

  return (
    <div style={styles.navbar}>
      {showBackButton && (
        <button
          onClick={() => navigate(-1)}
          style={styles.backButton}
        >
          ← <span style={styles.backButtonText}>Voltar</span>
        </button>
      )}
      <h1 style={styles.navbarTitle}>{title}</h1>
    </div>
  );
};

// Footer Component
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer style={styles.footer}>
      <p style={styles.footerText}>© {currentYear} - Sistema de Saúde</p>
    </footer>
  );
};

// Modal Component
const ConfirmModal = ({ visible, title, message, onConfirm, onCancel, confirmText = "Confirmar" }) => {
  if (!visible) return null;

  return (
    <div style={styles.modalOverlay} onClick={onCancel}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3 style={styles.modalTitle}>{title}</h3>
        <p style={{ textAlign: 'center', marginBottom: '20px' }}>{message}</p>
        <div style={styles.modalButtons}>
          <button
            style={{ ...styles.modalButton, ...styles.modalButtonCancel }}
            onClick={onCancel}
          >
            Cancelar
          </button>
          <button
            style={{ ...styles.modalButton, ...styles.modalButtonConfirm }}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

// Format phone number helper
const formatPhoneNumber = (phone) => {
  if (!phone || typeof phone !== 'string') {
    return 'Não disponível';
  }
  
  const cleaned = phone.replace(/\D/g, '');
  
  if (cleaned.length < 10 || cleaned.length > 11) {
    return phone;
  }
  
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  } else if (cleaned.length === 11) {
    return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }
  
  return phone;
};

// Contact Card Component
const ContactCard = ({ icon: IconComponent, iconColor, type, value, hint, onPress, disabled }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        ...styles.contactCard,
        ...(isHovered && !disabled ? styles.contactCardHover : {}),
        ...(disabled ? styles.disabledCard : {})
      }}
      onClick={!disabled ? onPress : undefined}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={styles.cardIconContainer}>
        <IconComponent style={{ ...styles.cardIcon, color: iconColor }} />
      </div>
      <div style={styles.cardContent}>
        <div style={styles.contactType}>{type}</div>
        <div style={styles.contactValue}>{value}</div>
        <div style={styles.contactHint}>{hint}</div>
      </div>
      <IoChevronForward style={styles.chevronIcon} />
    </div>
  );
};

export default function FaleConoscoScreen() {
  const [contato, setContato] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: '',
    message: '',
    onConfirm: null,
    confirmText: 'Confirmar'
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchContato = async () => {
      try {
        const storedLink = storage.getItem('link');
        const storedChave = storage.getItem('chave');
        const storedGuid = storage.getItem('govbr_guid');
        const guidParam = storedGuid ? `&GUID=${storedGuid}` : '';

        if (!storedLink || !storedChave) {
          setLoading(false);
          return;
        }

        const url = `${storedLink}/apidadospaciente.rule?sys=SAU&p1=${storedChave}&p2=contato${guidParam}`;
        //console.log('URL da API (contato):', url);
        
        const response = await fetch(url);
        const data = await response.json();

        //console.log('Resposta da API (contato):', data);

        if (data.status === 'success' && data.dados && data.dados.length > 0) {
          setContato(data.dados[0]);
        } else {
          //console.log('API não retornou dados de contato válidos');
          setContato(null);
        }
      } catch (error) {
        //console.log('Erro ao buscar dados de contato:', error);
        setContato(null);
      } finally {
        setLoading(false);
      }
    };

    fetchContato();
  }, []);

  // Função para verificar se há dados
  const hasAnyData = () => {
    return contato !== null && typeof contato === 'object' && 
           (contato.EMAIL || contato.WHATSAPP || contato.TELEFONE);
  };

  const handleWhatsAppPress = () => {
    if (contato?.WHATSAPP) {
      setModalConfig({
        title: 'Abrir WhatsApp',
        message: `Deseja entrar em contato via WhatsApp?`,
        confirmText: 'Abrir',
        onConfirm: () => {
          const contatoTratado = contato.WHATSAPP.replace(/[^0-9]/g, "");
          window.open(`https://wa.me/55${contatoTratado}`, '_blank');
          setShowModal(false);
        }
      });
      setShowModal(true);
    } else {
      setModalConfig({
        title: 'Informação',
        message: 'WhatsApp não disponível',
        confirmText: 'OK',
        onConfirm: () => setShowModal(false)
      });
      setShowModal(true);
    }
  };

  const handleEmailPress = () => {
    if (contato?.EMAIL) {
      setModalConfig({
        title: 'Enviar E-mail',
        message: `Deseja enviar um e-mail para ${contato.EMAIL}?`,
        confirmText: 'Enviar',
        onConfirm: () => {
          window.location.href = `mailto:${contato.EMAIL}`;
          setShowModal(false);
        }
      });
      setShowModal(true);
    } else {
      setModalConfig({
        title: 'Informação',
        message: 'E-mail não disponível',
        confirmText: 'OK',
        onConfirm: () => setShowModal(false)
      });
      setShowModal(true);
    }
  };

  const handlePhonePress = () => {
    if (contato?.TELEFONE) {
      setModalConfig({
        title: 'Ligar',
        message: `Deseja ligar para ${formatPhoneNumber(contato.TELEFONE)}?`,
        confirmText: 'Ligar',
        onConfirm: () => {
          window.location.href = `tel:${contato.TELEFONE.replace(/\D/g, '')}`;
          setShowModal(false);
        }
      });
      setShowModal(true);
    } else {
      setModalConfig({
        title: 'Informação',
        message: 'Telefone não disponível',
        confirmText: 'OK',
        onConfirm: () => setShowModal(false)
      });
      setShowModal(true);
    }
  };

  return (
    <div style={styles.mainContainer}>
      <NavBar title="Fale Conosco" showBackButton={true} />

      <div style={styles.scrollContainer}>
        {loading ? (
          <div style={styles.loadingContainer}>
            <div style={styles.loadingSpinner} />
            <div style={styles.loadingText}>Carregando informações...</div>
          </div>
        ) : !hasAnyData() ? (
          <div style={styles.emptyContainer}>
            <IoChatbubbleEllipsesOutline style={styles.emptyIcon} />
            <div style={styles.emptyText}>Nenhum dado de contato encontrado</div>
            <div style={styles.emptySubText}>
              Consulte a Unidade de Saúde para obter informações de contato.
            </div>
          </div>
        ) : (
          <>
            <div style={styles.headerContainer}>
              <IoChatbubblesOutline style={styles.headerIcon} />
              <h1 style={styles.title}>Entre em contato conosco</h1>
              <p style={styles.subtitle}>Estamos aqui para ajudar você!</p>
            </div>

            {/* WhatsApp */}
            <ContactCard
              icon={IoLogoWhatsapp}
              iconColor="#25D366"
              type="WhatsApp"
              value={contato?.WHATSAPP ? formatPhoneNumber(contato.WHATSAPP) : 'Não disponível'}
              hint={contato?.WHATSAPP ? 'Toque para abrir o WhatsApp' : 'Informação não disponível'}
              onPress={handleWhatsAppPress}
              disabled={!contato?.WHATSAPP}
            />

            {/* Telefone */}
            <ContactCard
              icon={IoCallOutline}
              iconColor="#137a7f"
              type="Telefone"
              value={contato?.TELEFONE ? formatPhoneNumber(contato.TELEFONE) : 'Não disponível'}
              hint={contato?.TELEFONE ? 'Toque para ligar' : 'Informação não disponível'}
              onPress={handlePhonePress}
              disabled={!contato?.TELEFONE}
            />

            {/* Email */}
            <ContactCard
              icon={IoMailOutline}
              iconColor="#666"
              type="E-mail"
              value={contato?.EMAIL || 'Não disponível'}
              hint={contato?.EMAIL ? 'Toque para enviar e-mail' : 'Informação não disponível'}
              onPress={handleEmailPress}
              disabled={!contato?.EMAIL}
            />

            <div style={styles.infoContainer}>
              <IoInformationCircleOutline style={styles.infoIcon} />
              <p style={styles.infoText}>
                Horário de atendimento: Segunda a Sexta, 8h às 17h
              </p>
            </div>
          </>
        )}
      </div>
      
      <Footer />

      <ConfirmModal
        visible={showModal}
        title={modalConfig.title}
        message={modalConfig.message}
        confirmText={modalConfig.confirmText}
        onConfirm={modalConfig.onConfirm}
        onCancel={() => setShowModal(false)}
      />
    </div>
  );
}